export const setItemToSessionStorage = (key, value) => {
    const stringifiedValue = JSON.stringify(value)
    sessionStorage.setItem(key, stringifiedValue)
}

export const getItemFromSessionStorage = (key) => {
    const stringifiedValue = sessionStorage.getItem(key)
    return JSON.parse(stringifiedValue)
}

export const removeItemInSessionStorage = (key) => {
    sessionStorage.removeItem(key)
}

export const removeAllItemsInSessionStorage = () => {
    sessionStorage.clear()
}